import { Component, ElementRef, OnInit } from '@angular/core';
import { CompressImageService } from "../../services/common/compress-image.service";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { take } from "rxjs";
import { UploadImageModel } from "../../models/image/upload-image.model";
import { TranslateService } from "@ngx-translate/core";
import { DeleteImagesConfirmComponent } from "./delete-images-confirm/delete-images-confirm.component";


@Component({
  selector: 'app-multiple-images-upload',
  templateUrl: './multiple-images-upload.component.html',
  styleUrls: ['./multiple-images-upload.component.scss']
})
export class MultipleImagesUploadComponent implements OnInit {

  //#region Fields
  public venueId: string;
  public pictureFormat: Array<string>;
  public pictureIsWrongFormat: boolean = false;
  public tooManyFiles: boolean = false;
  // maxSize: number = 3000000;  //3 MB = 3000000 Bytes (in decimal)
  public images: UploadImageModel[] = [];
  public imagesToDelete: UploadImageModel[] = [];
  public deleteImages: boolean = false;
  //#endregion

  //#region Constructor
  constructor(
    private compressImage: CompressImageService,
    private openFile: ElementRef,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public translate: TranslateService
  ) {
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];

    if (this.config.data != undefined && this.config.data.venueId) {
      this.venueId = this.config.data.venueId;
    }
  }

  ngOnInit(): void {
    if (this.config.data != undefined && this.config.data.images) {
      this.config.data.images.forEach((image: any) => {
        if (image.imageId) {
          this.images.push({
            uploaded: true,
            imagePath: image.galeryImagePath,
            progress: 100,
            imageId: image.imageId
          });
        } else {
          this.images.push(image);
        }
      });
    }
  }
  //#endregion

  //#region Public Methods
  close(): void {
    this.ref.close(this.images);
  }

  onSelectFile(event: any): void {
    this.processImages(event.target.files);
  }

  onDropFile(files: any[]): void {
    this.processImages(files);
  }

  processImages(files: any []): void {
    this.tooManyFiles = files.length + this.images.length > 10;
    if (!this.fileFormatValid(files) || this.tooManyFiles) {
      return;
    }

    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        this.images.push({
          imagePath: '',
          progress: 0,
          imageName: file.name,
          filePicture: '',
          uploaded: false
        });
        let reader = new FileReader();
        this.compressImage.compress(file)
          .pipe(take(1))
          .subscribe(compressedImage => {
            let imageIndex = this.images.findIndex(x => x.imageName === file.name);
            this.images[imageIndex].filePicture = compressedImage;
          });
        reader.onload = (item) => {
          let imageIndex = this.images.findIndex(x => x.imageName === file.name);
          this.images[imageIndex].imagePath = item.target?.result;
          this.images[imageIndex].progress = 100;
        }
        reader.onprogress = (event) => {
          let imageIndex = this.images.findIndex(x => x.imageName === file.name);
          this.images[imageIndex].progress = (event.loaded / event.total) * 100;
        }
        reader.readAsDataURL(file);
      }
    }
  }

  openAddImage(): void {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }

  fileFormatValid(files: any[]): boolean {
    this.pictureIsWrongFormat = false;
    for (let i = 0; i < files.length; i++) {
      if (!this.pictureFormat.includes(files[i].type)) {
        this.pictureIsWrongFormat = true;
        return false;
      }
    }
    return true;
  }

  enableDeleteImages(): void {
    this.deleteImages = true;
  }

  deleteSelectedImages(): void {
    if (this.imagesToDelete.length === 0) {
      return;
    }
    const ref = this.dialogService.open(DeleteImagesConfirmComponent, {
      data: {
        venueId: this.venueId,
        images: this.imagesToDelete.filter(image => image.uploaded)
      },
      width: '380px',
      showHeader: false,
      styleClass: 'dialog_long'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.images = this.images.filter((image: UploadImageModel) => !this.imagesToDelete.includes(image));
      }
      this.deleteImages = false;
      this.imagesToDelete = [];
      this.tooManyFiles = this.images.length > 10;
    });
  }
  //#endregion
}
